import { SegmentedControl, Tooltip } from "@mantine/core";
import React, { useState } from "react";
import WidgetWrapper from "../../../../components/WidgetWrapper/WidgetWrapper";
import MyIssues from "../../issuesApp/MyIssues";
import UserCreatedChecklistsInProject from "./UserCreatedChecklistsInProject";
import UserParticipantInMeeting from "./UserParticipantInMeeting";

const UserItemsInProject: React.FC<{ app: string }> = ({ app }) => {
  const [activeView, setActiveView] = useState<string>("Tasks");

  const segmentedData = [
    {
      label: (
        <Tooltip label="Trykk for å vise dine oppgaver" withArrow openDelay={300} offset={{ mainAxis: 12 }}>
          <span>Oppgaver</span>
        </Tooltip>
      ),
      value: "Tasks",
    },
    {
      label: (
        <Tooltip label="Trykk for å vise dine møter" withArrow openDelay={300} offset={{ mainAxis: 12 }}>
          <span>Møter</span>
        </Tooltip>
      ),
      value: "Meetings",
    },
    {
      label: (
        <Tooltip label="Trykk for å vise dine sjekklister" withArrow openDelay={300} offset={{ mainAxis: 12 }}>
          <span>Sjekklister</span>
        </Tooltip>
      ),
      value: "Checklists",
    },
  ];

  return (
    <WidgetWrapper
      widgetKey="tasks"
      customButtons={
        <SegmentedControl
          value={activeView}
          onChange={(val) => setActiveView(val)}
          data={segmentedData}
          size="md"
          color={"mc-primary"}
        />
      }
    >
      {activeView === "Tasks" && <MyIssues />}
      {activeView === "Meetings" && <UserParticipantInMeeting />}
      {activeView === "Checklists" && <UserCreatedChecklistsInProject />}
    </WidgetWrapper>
  );
};

export default UserItemsInProject;
